import styled from "styled-components";
import { Row as sbgRow } from "styled-bootstrap-grid";

const Row = styled(sbgRow)`
`;

export default Row;
